import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { connect } from 'react-redux';
import { Button } from '@piplapps/pipl-ui';
import LoadingButton from '../../../Components/LoadingButton';
import styles from './EnforceAuthModal.module.less';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';

const EnforceAuthModal = (props) => {
  const _handleSwitchChange = useCallback(() => {
    if (props.status) {
      props.disableLogin();
      props.toggleModal(false);
    } else {
      props.enableLogin();
      props.toggleModal(false);
    }
  }, [props.status]);

  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>
        {gettext(props.status ? `Force login with ${props.auth}` : `Disable Force login with ${props.auth}`)}
      </div>
      <span
        role="button"
        tabIndex={0}
        className={styles.close}
        onClick={() => {
          props.toggleModal(false);
        }}
      >
        &times;
      </span>

      {!props.status && (
        <div className={styles.text}>
          {gettext(
            `Are you sure you wish to enable "Force login with ${props.auth}"? ` +
              `All users will be forced to log in with their ${props.auth} account.`,
          )}
        </div>
      )}
      {props.status && (
        <div className={styles.text}>
          {gettext(
            `Are you sure you wish to disable "Force login with ${props.auth}"? ` +
              `This will allow users to log in without their ${props.auth} account.`,
          )}
        </div>
      )}

      <div className={styles.buttonContainer}>
        <div className={styles.buttonWrapper}>
          <AnalyticsHandler
            eventName={AnalyticsEventNames.SSO_SETTINGS_UPDATE}
            eventData={{ ssoProvider: props.auth, ssoStatus: !props.status }}
          >
            <LoadingButton
              buttonClass={props.status ? 'primary-orange' : 'primary-blue'}
              type="submit"
              onClick={_handleSwitchChange}
              text={props.status ? gettext('Disable') : gettext('Enable')}
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonWrapper}>
          <Button buttonClass="secondary-blue" onClick={() => props.toggleModal(false)} text={gettext('Cancel')} />
        </div>
      </div>
    </div>
  );
};

EnforceAuthModal.propTypes = {
  toggleModal: PropTypes.func,
  disableLogin: PropTypes.func,
  enableLogin: PropTypes.func,
  status: PropTypes.bool,
  auth: PropTypes.string,
};

const mapDispatchToProps = {};

export default connect(null, mapDispatchToProps)(EnforceAuthModal);
